import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import { IsAuthenticated, IsChangePassword } from "./services/auth";

import Redes from "./pages/Redes";
import PartialMonthSector from "./pages/Report/PartialMonthSector";
import AgentOpened from "./pages/Report/AgentOpened";
import PaymentsConference from "./pages/Report/PaymentsConference";
import Payments from "./pages/Payments";
import AgentPerformance from "./pages/Report/AgentPerformance";
import AgentMonth from "./pages/Report/AgentProductivityMonth";
import NotReturned from "./pages/Report/NotReturned";
import Debts from "./pages/Report/Debts";
import ConferencesByAgent from "./pages/Report/ConferencesByAgent";
import AgentHistory from "./pages/Report/AgentHistory";
import Opened from "./pages/Report/Opened";
import TopSales from "./pages/Report/TopSales";
import SectorProductivity from "./pages/Report/SectorProductivity";
import Prevision from "./pages/Report/Prevision";
import AgentProductivityMonth from "./pages/Report/ProductivityMonth";
import PartialMonth from "./pages/Report/PartialMonth";
import SummaryMonthGs from "./pages/Report/SummaryMonthGs";
import NotFound from "./pages/404";
import Logon from "./pages/Logon";
import Apoio from "./pages/Apoio";
import Videos from "./pages/Apoio/Videos";
import Material from "./pages/Apoio/Material";
import Home from "./pages/Home";
import Control from "./pages/Control";
import Production from "./pages/Production";
import Report from "./pages/Report";
import Categories from "./pages/Categories";
import Products from "./pages/Products";
import Kits from "./pages/Kits";
import CadastrarKit from "./pages/Kits/CadastrarKit";
import GerenciarKit from "./pages/Kits/GerenciarKit";
import RegionalManagers from "./pages/RegionalManagers";
import SectorManagers from "./pages/SectorManagers";
import Agents from "./pages/Agents";
import Resellers from "./pages/Resellers";
import Operators from "./pages/Operators";
import Orders from "./pages/Orders";
import CadastrarPedido from "./pages/Orders/CadastrarPedido";
import EditarPedido from "./pages/Orders/EditarPedido";
import Conference from "./pages/Conference";
import ConferenceList from "./pages/Conference/ConferenceList";
import ConferenceKit from "./pages/Conference/ConferenceKit";
import ConferenceAgents from "./pages/Conference/ConferenceAgents";
import ConferenceAgent from "./pages/Conference/ConferenceAgent";
import ConferenceSectors from "./pages/Conference/ConferenceSectors";
import ConferenceSector from "./pages/Conference/ConferenceSector";
import Exchanges from "./pages/Exchanges";
import ChangePassword from "./pages/Profile/ChangePassword";
import Profile from "./pages/Profile";
import UserNotifications from "./pages/Notifications/UserIndex";
import AdminNotifications from "./pages/Notifications/AdminIndex";
import AdminStatusNotificacao from "./pages/Notifications/AdminStatusNotificacao";
import Consults from "./pages/Consults";
import CadastrarEntrada from "./pages/Payments/CadastrarEntrada";

const NeedChangePassword = (Component: any, props: any): React.ReactNode => (
    !IsChangePassword()
        ? <Component {...props} />
        : <Redirect to={{ pathname: "/user/changepassword", state: { from: props.location } }} />
);

const PrivateRoute = ({ component: Component, ...rest }: any) => (
    <Route
        {...rest}
        render={props =>
            !IsAuthenticated()
                ? <Redirect to={{ pathname: "/", state: { from: props.location } }} />
                : NeedChangePassword(Component, props)
        }
    />
);

const ResetRoute = ({ component: Component, ...rest }: any) => (
    <Route
        {...rest}
        render={props =>
            IsChangePassword()
                ? <Component {...props} />
                : <Redirect to={{ pathname: "/app", state: { from: props.location } }} />
        }
    />
);

const AuthRoute = ({ component: Component, ...rest }: any) => (
    <Route
        {...rest}
        render={props =>
            !IsAuthenticated()
                ? <Component {...props} />
                : <Redirect to={{ pathname: "/app", state: { from: props.location } }} />
        }
    />
);

const Routes: React.FC = () => (
    <>
        <BrowserRouter>
            <Switch>
                <AuthRoute exact path="/" component={Logon} />
                <ResetRoute path="/user/changepassword" component={ChangePassword} />
                <PrivateRoute path="/apoio" component={Apoio} />
                <PrivateRoute path="/videos" component={Videos} />
                <PrivateRoute path="/material" component={Material} />
                <PrivateRoute path="/user/profile" component={Profile} />
                <PrivateRoute path="/control" component={Control} />
                <PrivateRoute path="/production" component={Production} />
                <PrivateRoute path="/categories" component={Categories} />
                <PrivateRoute path="/products" component={Products} />
                <PrivateRoute path="/exchanges" component={Exchanges} />
                <PrivateRoute path="/kits" component={Kits} />
                <PrivateRoute path="/createkit" component={CadastrarKit} />
                <PrivateRoute path="/managekit/:id" component={GerenciarKit} />
                <PrivateRoute path="/report" component={Report} />
                <PrivateRoute path="/signup" component={() => <h1>SignUp</h1>} />
                <PrivateRoute path="/app" component={Home} />
                <PrivateRoute path="/regionalmanagers" component={RegionalManagers} />
                <PrivateRoute path="/sectormanagers" component={SectorManagers} />
                <PrivateRoute path="/agents" component={Agents} />
                <PrivateRoute path="/resellers" component={Resellers} />
                <PrivateRoute path="/operators" component={Operators} />
                <PrivateRoute path="/orders" component={Orders} />
                <PrivateRoute path="/createorder" component={CadastrarPedido} />
                <PrivateRoute path="/updateorder/:id" component={EditarPedido} />
                <PrivateRoute path="/conference" component={Conference} />
                <PrivateRoute path="/conferencelist" component={ConferenceList} />
                <PrivateRoute path="/conferencekit/:id" component={ConferenceKit} />
                <PrivateRoute path="/conferenceagents" component={ConferenceAgents} />
                <PrivateRoute path="/conferenceagent/:id" component={ConferenceAgent} />
                <PrivateRoute path="/conferencesectors" component={ConferenceSectors} />
                <PrivateRoute path="/conferencesector/:id" component={ConferenceSector} />
                <PrivateRoute path="/user/notifications" component={UserNotifications} />
                <PrivateRoute exact path="/admin/notifications" component={AdminNotifications} />
                <PrivateRoute exact path="/admin/notifications/:id/status" component={AdminStatusNotificacao} />
                <PrivateRoute path="/consults" component={Consults} />
                <PrivateRoute path="/summarymonthgs" component={SummaryMonthGs} />
                <PrivateRoute path="/partialmonth" component={PartialMonth} />
                <PrivateRoute path="/agentproductivitymonth" component={AgentProductivityMonth} />
                <PrivateRoute path="/prevision" component={Prevision} />
                <PrivateRoute path="/sectorproductivity" component={SectorProductivity} />
                <PrivateRoute path="/topsales" component={TopSales} />
                <PrivateRoute path="/opened" component={Opened} />
                <PrivateRoute path="/agenthistory" component={AgentHistory} />
                <PrivateRoute path="/conferencesbyagent" component={ConferencesByAgent} />               
                <PrivateRoute path="/debts" component={Debts} />
                <PrivateRoute path="/notreturned" component={NotReturned} />
                <PrivateRoute path="/agentmonth" component={AgentMonth} />
                <PrivateRoute path="/agentperformance" component={AgentPerformance} />
                <PrivateRoute path="/entradas" component={Payments} />
                <PrivateRoute path="/createpayment" component={CadastrarEntrada} />
                <PrivateRoute path="/paymentsconference" component={PaymentsConference} />
                <PrivateRoute path="/agentopened" component={AgentOpened} />    
                <PrivateRoute path="/partialmonthsector" component={PartialMonthSector} />            
                <PrivateRoute path="/redessociais" component={Redes} />                
                
                <Route path="*" component={NotFound} />
            </Switch>
        </BrowserRouter>
    </>
);

export default Routes;
